<div class="card smooth-shadow mb-4 pb-0">
    <td-title-skeleton></td-title-skeleton>
    <ng-content></ng-content>
</div>
